export default __webpack_public_path__ + "static/mister-umbrella-880e7d9216dc555ba6db87f26d44a172.svg";